import { useTranslation } from 'react-i18next'

import Button from '../../../../Button'
import Text from '../../../../Text'

import * as styles from './ViewEntireMessageButton.module.css'

function ViewEntireMessageButton({
  className = styles.ViewEntireMessageButton,
  onClick,
}) {
  const { t } = useTranslation()

  return (
    <div className={className}>
      <Text>{t('EmailProfile.MessageClippedKey')}</Text>
      <Button.Text
        text={t('EmailProfile.ViewEntireMessageButtonKey')}
        onClick={onClick}
      />
    </div>
  )
}

export default ViewEntireMessageButton
